module.exports = function() {
  return new Worker(__webpack_public_path__ + "559544207e6c9762bbe6.worker.js");
};